module.exports = __webpack_public_path__ + "img/logo-loader.391948f6.jpg";